import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";

/** Components */
import CreateRa from "./create-ra/CreateRa";
import EditRa from "./ra-edit/RaEdit";
import InsMS from "./insertms/InsertMobilityStore";
import SearchToolMS from "./searchms/SearchTool";
import Manager_RFM from "./contractor-main/Manager_RFM";
import OpenRoyaltiesFeesManagement from "./contractor-search/OpenRoyaltiesFeesManagement";
import SearchDms from "./search-dms/SearchDms";
import SearchRs from "./search-repair-shop/SearchRs";
import ApplicationDetail from "./application-detail/ApplicationDetail";
import DmsDetail from "./dms-detail/DmsDetail";
import RsDetail from "./rs-detail/RsDetail";
import RaDetail from "./ra-detail/RaDetail";
import CheckIn from "./check-out-in/CheckIn";
import CheckOut from "./check-out-in/CheckOut";
import RaSearch from "./ra-search/RaSearch";
import VoidManagement from "./void-management/VoidManagement";
import ExtensionManagement from "./extension-management/ExtensionManagement";
import ClaimInsertion from "./claim-insertion/ClaimInsertion";
import RoyaltiesConfigurationPanel from "./contractor-main/component/RoyaltiesConfigurationPanel";
import RoyaltiesVoices from "./contractor-main/component/RoyaltiesVoices";
import OpenCloseTimeframe from "./dms-detail/tabs-section/tabs/OpenCloseTimeframe";
import TimeframePanel from "./dms-detail/tabs-section/tabs/TimeframePanel";
import ParkingTool from "./parking-tool/ParkingTool";
import EnableRecovery from "./enable-recovery/EnableRecovery";
import PaymentReconciliation from "./payment-reconciliation/PaymentReconciliation";
import ActivationSetupPanel from "./dms-detail/tabs-section/tabs/ActivationSetupPanel";
import RaVehicleIdentification from "./check-out-in/ra-vehicle-identification/ra-vehicle-identification";
import {CBAuth} from "../customerbase/types";
import NotAuthorizedDialog from "../authentication/component/NotAuthorizedDialog";
import {NetworkScope} from "./types";
import {useHasScope} from "../../config/globalConfig";
import {RecoveryScope} from "../recovery/types";
import RecoveryCheckIn from "./check-out-in/RecoveryCheckIn";
import RecoveryCheckOut from "./check-out-in/RecoveryCheckOut";
import RsExportPage from "./rs-export/RsExportPage";

/** Styles */
import "./networkMain.css";
import MsHoliday from "./ms-holiday/MsHoliday";

const NetworkMain = () => {
   const hasScope = useHasScope;

    return (
        <Routes>
            <Route path="/create-ra/:id" element={
                 hasScope(NetworkScope.RaInsert) ?
                    <RecoilRoot key={'createRA'}>
                        <CreateRa />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/edit-ra/:id" element={
                <RecoilRoot key={'edtiRA'}>
                    <EditRa />
                </RecoilRoot>
            } />

            <Route path="/ra-search" element={
                hasScope(NetworkScope.RaList)||hasScope(CBAuth.VIEW_RENTAL_AGREEMENTS)?
                    <RecoilRoot key={'ra-search'}>
                        <RaSearch type={'general'} />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/expired-ra-search" element={
                hasScope( NetworkScope.RaListExpired) ?
                    <RecoilRoot key={'expired-ra-search'}>
                        <RaSearch type={'expired'}/>
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/ra-detail/:id" element={
                 hasScope(NetworkScope.RaDetail)||hasScope(CBAuth.VIEW_RENTAL_AGREEMENTS)?
                    <RecoilRoot key={'ra-detail'}>
                        <RaDetail />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/payment-reconciliation/:id" element={
                 // hasScope(NetworkScope.RaDetail)||hasScope(CBAuth.VIEW_RENTAL_AGREEMENTS)?
                    <RecoilRoot key={'payment-reconciliation'}>
                        <PaymentReconciliation />
                    </RecoilRoot>
                // : <NotAuthorizedDialog/>
            } />

            <Route path="/extension-management/:id" element={
                 hasScope(NetworkScope.RaInsert) ?
                    <RecoilRoot key={'extension-management'}>
                        <ExtensionManagement />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/claim-insertion/:id" element={
                 hasScope(NetworkScope.RaInsert) ?
                    <RecoilRoot key={'claim-insertion'}>
                        <ClaimInsertion />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/ra-vehicle-identification/:type" element={
                 hasScope(NetworkScope.CheckIn)||hasScope(NetworkScope.CheckOut)?
                    <RecoilRoot key={'ra-vehicle-identification'}>
                        <RaVehicleIdentification />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/check-in/:id" element={
                hasScope(NetworkScope.CheckIn)||hasScope(NetworkScope.CheckOut)?
                    <RecoilRoot key={'check-in'}>
                        <CheckIn />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/check-out/:id" element={
                hasScope(NetworkScope.CheckIn)||hasScope(NetworkScope.CheckOut)?
                    <RecoilRoot key={'check-out'}>
                        <CheckOut />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/recovery-check-in/:id" element={
                hasScope(RecoveryScope.RaInsertCheckInRecovery) ?
                    <RecoilRoot key={'check-in'}>
                        <RecoveryCheckIn />
                    </RecoilRoot> :
                    <NotAuthorizedDialog/>
            } />

            <Route path="/recovery-check-out/:id" element={
                hasScope(RecoveryScope.RaInsertCheckOutRecovery) ?
                    <RecoilRoot key={'check-out'}>
                        <RecoveryCheckOut />
                    </RecoilRoot>
                    : <NotAuthorizedDialog/>
            } />

            <Route path="/open-void/:id" element={
                 hasScope(NetworkScope.RaInsert) ?
                    <RecoilRoot key={'openVoid'}>
                        <VoidManagement />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/dms-search" element={
                hasScope( NetworkScope.MsList) ?
                    <RecoilRoot key={'dmsManagment'}>
                        <SearchDms />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/dms-detail/:id" element={
                hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'dmsManagment'}>
                        <DmsDetail />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/enable-recovery" element={
                hasScope( NetworkScope.MsEnableRecovery) ?
                <RecoilRoot key={'enableRecovery'}>
                    <EnableRecovery/>
                </RecoilRoot>
                : <NotAuthorizedDialog/>
            }/>

            <Route path="/mslist" element={
                hasScope( NetworkScope.MsApplicationMngList) ?
                    <RecoilRoot key={'applicationManagment'}>
                        <SearchToolMS />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/application-detail/:id" element={
                hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'applicationManagment'}>
                        <ApplicationDetail />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/contractor-mng" element={
                hasScope( NetworkScope.MsContractorMngList) ?
                    <RecoilRoot key={'contractor-mng-main'}>
                        <OpenRoyaltiesFeesManagement />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/contractor-mng/:id" element={
                hasScope( NetworkScope.MsMng) ?
                    <RecoilRoot key={'contractor-mng-modify'}>
                        <Manager_RFM />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/contractor-royalties" element={
                hasScope( NetworkScope.MsRoyaltiesMngList) ?
                    <RecoilRoot key={'contractor-royalties-conf'}>
                        <RoyaltiesConfigurationPanel/>
                    </RecoilRoot>
                    : <NotAuthorizedDialog/>
            } />

            <Route path="/contractor-royalties-detail" element={
                hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'contractor-royalties-detail'}>
                        <RoyaltiesVoices />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/timeframe-panel" element={
                hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'timeframe-panel'}>
                        <TimeframePanel />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/open-close-timeframe/:id" element={
                 hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'timeframe-panel'}>
                        <OpenCloseTimeframe />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/activation-setup-panel" element={
                 hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'activation-setup-panel'}>
                        <ActivationSetupPanel />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/repair-shop" element={
                hasScope( NetworkScope.MsList) ?
                    <RecoilRoot key={'rsManagment'}>
                        <SearchRs />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/repair-shop/:id" element={
                hasScope( NetworkScope.MsDetail) ?
                    <RecoilRoot key={'rsManagment'}>
                        <RsDetail />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/rs-excel-export" element={
                hasScope( NetworkScope.MsRepairShopList) ?
                <RecoilRoot key={'rs-export'}>
                    <RsExportPage exportType={"SHOP"} />
                </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />

            <Route path="/parking-tool" element={
                // hasScope( NetworkScope.ParkingTool) ?
                    <RecoilRoot key={'parking-tool'}>
                        <ParkingTool />
                    </RecoilRoot>
                // : <NotAuthorizedDialog/>
            } />

            <Route path="/public-holidays" element={
                hasScope( NetworkScope.ViewMsHoliday) ?
                    <RecoilRoot key={'ms-holiday'}>
                        <MsHoliday />
                    </RecoilRoot>
                : <NotAuthorizedDialog/>
            } />
        </Routes>
    );
}

export default NetworkMain;
